import { useMemo } from 'react'

import { useCommonServices, usePageShow } from '@lib/hooks'
import { useTrackingInit } from '@lib/hooks'
import { usePersistMailExtension } from '@lib/hooks/use-persist-mail-extension'
import { withCurrentUser } from '@lib/mixins/with-current-user'

import type { PageComponentProps } from '@typings/components/page'

import { CmsPageBody } from '@components/page-core/body/body'
import { formatPageSlug } from '@components/page-core/utils'

import { PageShell } from '../page-shell/page-shell'

export const CmsPage = withCurrentUser(
  ({ isPreview, data, metadata, isStaticFallback = false }: PageComponentProps) => {
    const { pageId, isSectionScrollTrackingEnabled } = data?.fields ?? {}
    const slug = formatPageSlug(useCommonServices().shWebServerService.get().pageSlug ?? 'unknown')

    useTrackingInit(pageId, slug)
    usePageShow({ pageId, pageSlug: slug, isPreview, isStaticFallback })
    usePersistMailExtension()

    const contextValue = useMemo(
      () => ({
        pageId,
        slug,
        isPreview,
        isSectionScrollTrackingEnabled,
      }),
      [pageId, slug, isPreview, isSectionScrollTrackingEnabled],
    )

    return (
      <PageShell pageContext={contextValue} metadata={metadata}>
        <CmsPageBody data={data} />
      </PageShell>
    )
  },
)
